import styled from 'styled-components';
import StyledParagraph from '/shared/styled/components/StyledParagraph';

const StyledBuildingRefrigerantsSchemaHint = styled(StyledParagraph)`
  margin-left: 16.25rem;
`;

export default StyledBuildingRefrigerantsSchemaHint;
